module.exports = __webpack_public_path__ + "media/images/top/seminars/template/image09-bb32ac34b06669d033c7e817cad3edeb.jpeg";